import { Typography } from '@mui/material';
import type { DateGroup } from '../../../types/plotTimeline';

export interface TimeGroupHeaderProps {
  dateGroup: DateGroup;
}

/**
 * Date group header for timeline sections
 * Displays: "Today", "Yesterday", "This Week", or "Older"
 */
export function TimeGroupHeader({ dateGroup }: TimeGroupHeaderProps) {
  return (
    <Typography
      variant="caption"
      sx={{
        color: 'text.secondary',
        textTransform: 'uppercase',
        fontWeight: 600,
        letterSpacing: '0.5px',
        mb: 1,
        display: 'block',
      }}
    >
      {dateGroup}
    </Typography>
  );
}
